import { useEffect, useRef } from 'react';
import type { BeadPalette, CellColorId } from '../types';
import { getPaletteColor } from '../data/palette';

type MiniPatternCanvasProps = {
  width: number;
  height: number;
  cells: CellColorId[];
  palette: BeadPalette;
  size?: number;
  label: string;
};

export default function MiniPatternCanvas({ width, height, cells, palette, size = 92, label }: MiniPatternCanvasProps) {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const dpr = window.devicePixelRatio || 1;
    canvas.width = size * dpr;
    canvas.height = size * dpr;
    canvas.style.width = `${size}px`;
    canvas.style.height = `${size}px`;
    const context = canvas.getContext('2d');
    if (!context) return;

    context.scale(dpr, dpr);
    context.clearRect(0, 0, size, size);
    const cellSize = size / Math.max(width, height);
    const offsetX = (size - width * cellSize) / 2;
    const offsetY = (size - height * cellSize) / 2;

    cells.forEach((colorId, index) => {
      if (colorId === 'transparent') return;
      const x = index % width;
      const y = Math.floor(index / width);
      context.fillStyle = getPaletteColor(palette, colorId).hex;
      context.fillRect(offsetX + x * cellSize, offsetY + y * cellSize, cellSize, cellSize);
    });
  }, [cells, height, palette, size, width]);

  return <canvas ref={canvasRef} aria-label={label} className="mini-pattern-canvas" />;
}
